import React from "react";
import { BiCheckDouble } from "react-icons/bi";

const RightMessageSection = ({ text, time, isSeen }) => {
  return (
    <>
      <div className="flex justify-start mt-3 relative">
        <div className="p-3 bg-[#DBEBFF] text-[#284184] rounded-br-xl rounded-bl-xl rounded-tr-xl max-w-[300px]">
          <span className="text-base">{text}</span>
          <p className="flex items-center gap-1 justify-end text-[#284184]">
            <span className="text-[#496ECC] text-sm mt-1">{time}</span>
            {isSeen && (
              <span>
                <BiCheckDouble color="#496ECC" size={20} />
              </span>
            )}
          </p>
        </div>
      </div>
    </>
  );
};

export default RightMessageSection;
